import api from "./Api";

class PedidoService {
  GetPedido(payload) {
    return api.get("/v1/pedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedido(payload) {
    return api.post("/v1/pedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedido(payload) {
    return api.put("/v1/pedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedido(payload) {
    return api.delete("/v1/pedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoOData(payload) {
    return api.get("/OData/Pedido" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoKds(params = "") {
    return api.get("/v1/pedido/kds" + params).then((response) => response.data);
  }

  PutPedidoKdsStatus(payload) {
    return api
      .put("/v1/pedido/kds/status", payload)
      .then((response) => response.data);
  }

  GetPedidoKdsOperacao(id) {
    return api
      .get(`/v1/pedido/kds/${id}/operacao`)
      .then((response) => response.data);
  }

  ReimprimirPedidoKds(id) {
    return api
      .post(`/v1/pedido/kds/${id}/reimprimir`)
      .then((response) => response.data);
  }

  TentarFinalizacaoPedidoKds(id) {
    return api
      .post(`/v1/pedido/kds/${id}/tentar-finalizacao`)
      .then((response) => response.data);
  }

  ImprimirPedido(payload) {
    return api
      .get("/v1/pedido/Imprimir/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
    // return api.get("/v1/pedido/Imprimir/" + payload).then((response) => {
    //   return response;
    // });
  }
}

export default new PedidoService();
